import getFQDN from '../../rest'
import LOG from '../../../logging/Logger'

const DEV_PLAN_LIST = {
  prices: [
    {
      id: 'price_1IFFHqFcoAPn4NC2mRZt4mVS',
      priceCost: '$39 / year',
      period: 'yearly'
    },
    {
      id: 'price_1IFFH0FcoAPn4NC2XvuuXzT0',
      priceCost: '$4 / month',
      period: 'monthly'
    }
  ]
}

async function getPrices(handleRetrieveError) {
  try {
    const priceList = await fetch(getFQDN('v1/prices'), {
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    LOG.debug('getCurrentPrices response: ', priceList)
    const response = await priceList.json()
    LOG.debug('getCurrentPrices result:', response)

    // If the retrieve failed
    if (response.error) {
      return handleRetrieveError(response)
    }

    return response
  } catch (err) {
    LOG.error('getCurrentPrices error: ', err)
  }
}

export async function getCurrentPrices(handleRetrieveError) {
  const today = new Date()
  const PLAN_LIST_LS_KEY = 'priceList'
  const PLAN_LIST_CACHE_DAYS = 7
  let priceList = JSON.parse(localStorage.getItem(PLAN_LIST_LS_KEY))

  const expiryDt =
    priceList && priceList.expiry ? new Date(priceList.expiry) : new Date(today)

  if (!priceList || today > expiryDt) {
    let newPriceList = await getPrices(handleRetrieveError)

    if (!newPriceList) {
      if (process.env.NODE_ENV !== 'production') {
        newPriceList = DEV_PLAN_LIST
      }
    } else {
      priceList = newPriceList
    }

    const future = new Date(today)
    future.setDate(future.getDate() + PLAN_LIST_CACHE_DAYS)
    priceList.expiry = future
    localStorage.setItem(PLAN_LIST_LS_KEY, JSON.stringify(priceList))
  }
  return priceList.prices
}

export default getCurrentPrices
